import Component from './tiktok_campaign_analytics_dialog.vue'
export default Component
